import { render, staticRenderFns } from "./PredictorFooter.vue?vue&type=template&id=179098cc"
import script from "./PredictorFooter.vue?vue&type=script&lang=js"
export * from "./PredictorFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports